import { btn } from "@/ui/btn.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import { saveGame } from "@/core/saveGame";
import "@/styles/style.scss";
import "@/styles/components/level-bar.scss";

export function saveBtn(parent) {
  saveGame();
  const elem = btn({
    text: "Save game",
    parent: parent,
    classes: ["save", "btn", "controls-bar__item"],
    onClick: () => eventEmitter.emit("saveGame"),
  });
  return elem;
}
